// extracted by mini-css-extract-plugin
export default {"TableauBootstrap":"TableauComposante_TableauBootstrap__bWQrW","btn_stylo":"TableauComposante_btn_stylo__p8Nll"};